import { Injectable } from '@angular/core';
import { Observable, of  } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';

/*import {ModuleManual , ElementDefinition, ManualElement, ManualTextElement,
  ManualTableElement  } from './model';*/
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActiveContactPersoon, ActiveRelatie, ContactPersoon, Relatie,Land,Titulatuur } from '../model/relatie';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class RelatiesService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  data: any = [{'BedrijfNummer': 'test2', 'BedrijfsNaam': 'test2', 'Afkorting': 'test2', 'Straat':'test2'}];

  //baseURl: string = "https://i7xtibxeh4.execute-api.eu-central-1.amazonaws.com/Dev/";
  private baseURl: string = "http://localhost:3000/dev/";

  private configUrl = this.baseURl + 'relaties';

  private branches: any = null;
  private relatieTypes: any = null;
  private activeRelatieList: Array<ActiveRelatie> = null;
  private activeContactpersoonList : Array<ActiveContactPersoon> = null;

  /*
  manual = {
    intro : {logo: "", text: "Dit is een intro"},
    content : {logo: "", text: "Dit is een content"},
    learningObjectives : {logo: "", text: "Dit is een learningObjectives"}
  };
*/
  constructor(private http: HttpClient,private common : CommonService) {
      this.baseURl = environment.url;
      this.configUrl = this.baseURl + 'relaties';
   }



   getBranches(): Observable<any> {
        const me = this;
        if (this.branches != null ) {
            return new Observable<any>( (observer) => {
                observer.next(me.branches);
                observer.complete();
            } );
        }
        return new Observable<any>( (observer) => {
            this.http.get(this.baseURl +  "branches").pipe(
                tap(_ => this.log('fetched relatielist')),
                tap(e => { this.common.checkAndReportErrors(e)}),
                catchError(this.handleError<any>('getList', []))
                ).subscribe(data => {
                  me.branches = data;
                  observer.next(me.branches);
                  observer.complete();
              });
            });
  }

  getRelatieTypes(): Observable<any> {
    const me = this;
    if (this.relatieTypes != null ) {
        return new Observable<any>( (observer) => {
            observer.next(me.relatieTypes);
            observer.complete();
        } );
    }
    return new Observable<any>( (observer) => {
        this.http.get(this.baseURl +  "relatietypes").pipe(
            tap(_ => this.log('fetched relatielist')),
            tap(e => { this.common.checkAndReportErrors(e)}),
            catchError(this.handleError<any>('getList', []))
            ).subscribe(data => {
              me.relatieTypes = data;
              observer.next(me.relatieTypes);
              observer.complete();
          });
        });
}

getActiveRelatieList(): Observable<Array<ActiveRelatie>> {
  const me = this;
  if (this.activeRelatieList != null ) {
      return new Observable<any>( (observer) => {
          observer.next(me.activeRelatieList);
          observer.complete();
      } );
  }
  return new Observable<Array<ActiveRelatie>>( (observer) => {
      this.http.get(this.baseURl +  "relaties/activelist").pipe(
          tap(_ => this.log('fetched relatielist')),
          tap(e => { this.common.checkAndReportErrors(e)}),
          catchError(this.handleError<any>('getList', []))
          ).subscribe(data => {
            me.activeRelatieList = data;
            observer.next(me.activeRelatieList);
            observer.complete();
        });
      });
}

getActiveContactpersonenList(): Observable<Array<ActiveContactPersoon>> {
  const me = this;
  if (this.activeContactpersoonList != null ) {
      return new Observable<any>( (observer) => {
          observer.next(me.activeContactpersoonList);
          observer.complete();
      } );
  }
  return new Observable<Array<ActiveContactPersoon>>( (observer) => {
      this.http.get(this.baseURl +  "relaties/activeContactpersonenlist").pipe(
          tap(_ => this.log('fetched activeContactpersonenlist')),
          tap(e => { this.common.checkAndReportErrors(e)}),
          catchError(this.handleError<any>('getList', []))
          ).subscribe(data => {
            me.activeContactpersoonList = data;
            observer.next(me.activeContactpersoonList);
            observer.complete();
        });
      });
}

getContactpersonen(id):  Observable<any> {
  return this.http.get(this.baseURl +  "relaties/"+  id + "/contactpersonen").pipe(
    tap(_ => this.log('fetched contactpersonen')),
    tap(e => { this.common.checkAndReportErrors(e)}),
    catchError(this.handleError<any>('getContactpersonen', []))
  );
  }

  getAfleveradressen(id):  Observable<any> {
    return this.http.get(this.baseURl +  "relaties/"+  id + "/afleveradressen").pipe(
      tap(_ => this.log('fetched afleveradressen ')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getAfleveradressen', []))
    );
    }

    addAfleveradressen(id: number) {
      return this.http.post(this.configUrl + "/" + id + "/afleveradressen",{}, this.httpOptions).pipe(
        tap(_ => this.log('Afleveradressen saved')),
        tap(e => { this.common.checkAndReportErrors(e)}),
        catchError(this.handleError<any>('addAfleveradressen', []))
      );
    }

  saveAfleverAdres(AfleverAdres : any) {
      return this.http.put(this.configUrl + "/" + AfleverAdres.BedrijfNummer + "/afleveradressen/" +  AfleverAdres.ID ,AfleverAdres, this.httpOptions).pipe(
        tap(_ => this.log('AfleverAdres saved')),
        tap(e => { this.common.checkAndReportErrors(e)}),
        catchError(this.handleError<any>('saveAfleverAdres', []))
      );
  }

  deleteAfleverAdres(id : number,adresid: number) {
    return this.http.delete(this.configUrl + "/" + id + "/afleveradressen/" + adresid, this.httpOptions).pipe(
      tap(_ => this.log('afleveradressen deleted')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('deleteAfleverAdres', []))
    );
  }

  getRelatieRelatieTypes(id):  Observable<any> {
  return this.http.get(this.baseURl +  "relaties/"+  id + "/relatietypes").pipe(
    tap(_ => this.log('fetched relatielist')),
    tap(e => { this.common.checkAndReportErrors(e)}),
    catchError(this.handleError<any>('getList', []))
  );
  }

  addRelatieType(relatieid,id):  Observable<any> {
    return this.http.post(this.baseURl +  "relaties/"+  relatieid + "/relatietypes/" + id,{}, this.httpOptions).pipe(
      tap(_ => this.log('fetched addRelatieTyoe')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('addRelatieTyoe', []))
    );
    }

    deleteRelatieType(relatieid,id):  Observable<any> {
      return this.http.delete(this.baseURl +  "relaties/"+  relatieid + "/relatietypes/" + id, this.httpOptions).pipe(
        tap(_ => this.log('fetched deleteRelatieTyoe')),
        tap(e => { this.common.checkAndReportErrors(e)}),
        catchError(this.handleError<any>('deleteRelatieTyoe', []))
      );
      }

  getFactuurAdressen (id):  Observable<any> {
    return this.http.get(this.baseURl +  "relaties/"+  id + "/factuuradressen").pipe(
      tap(_ => this.log('fetched getFactuurAdressen')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getFactuurAdressen', []))
    );
    }

  getList(actief:boolean = true): Observable<any> {
    return this.http.get(this.configUrl + "?actief=" + actief).pipe(
      tap(_ => this.log('fetched relatielist')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getList', []))
    );
  }

  getRelatie(id : number) : Observable<any> {
    return this.http.get(this.configUrl + "/" + id).pipe(
      tap(_ => this.log('fetched relatieobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getRelatie', []))
    );
  }

  getRelatieByAfkorting(afkorting : string) : Observable<any> {
    return this.http.get(this.configUrl + "/afkorting/" + afkorting).pipe(
      tap(_ => this.log('fetched relatieobject')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getRelatie', []))
    );
  }


  deleteRelatie(id: number): Observable<any> {
    return this.http.delete(this.configUrl + "/" + id).pipe(
      tap(_ => this.log('fetched deleteRelatie')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('deleteRelatie', []))
    );
  }

  addRelatie(data) {
    return this.http.post(this.configUrl, data, this.httpOptions).pipe(
      tap(_ => this.log('relatieobject saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveRelatie', []))
    );

  }

  saveRelatie(id: Number, relatie: Relatie) {
    return this.http.put(this.configUrl + "/" + id ,relatie, this.httpOptions).pipe(
      tap(_ => this.log('relatieobject saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveRelatie', []))
    );
  }


  saveFactuuradres(factuurAdres : any) {
    return this.http.put(this.configUrl + "/" + factuurAdres.BedrijfNummer + "/factuuradressen/" +  factuurAdres.ID ,factuurAdres, this.httpOptions).pipe(
      tap(_ => this.log('factuurAdres saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveFactuuradres', []))
    );
  }

  addFactuurAdres(id : number) {
    return this.http.post(this.configUrl + "/" + id + "/factuuradressen",{}, this.httpOptions).pipe(
      tap(_ => this.log('factuurAdres saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveFactuuradres', []))
    );
  }

  deleteFactuuradres(id : number,adresid: number) {
    return this.http.delete(this.configUrl + "/" + id + "/factuuradressen/" + adresid, this.httpOptions).pipe(
      tap(_ => this.log('factuurAdres saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveFactuuradres', []))
    );
  }


  getContactpersoon(id : number) : Observable<ContactPersoon> {
    return this.http.get<ContactPersoon>(this.baseURl + "contactpersoon/" + id , this.httpOptions).
    pipe(retry(2),
      tap(_ => this.log('getContactpersoon')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getContactpersoon', []))
    );
  }
  saveContactpersoon(contactpersoon: ContactPersoon) {
    return this.http.put(this.baseURl + "contactpersoon/" + contactpersoon.ID ,contactpersoon, this.httpOptions).pipe(
      tap(_ => this.log('relatieobject saved')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('saveRelatie', []))
    );
  }

  getTitulatuur() : Observable<Array<Titulatuur>> {
    return this.http.get(this.baseURl + "contactpersoon/titulatuur"  , this.httpOptions).pipe(
      tap(_ => this.log('getContactpersoon')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getContactpersoon', []))
    );
  }
  getLanden() : Observable<Array<Land>> {
    return this.http.get(this.baseURl + "contactpersoon/landen"  , this.httpOptions).pipe(
      tap(_ => this.log('getContactpersoon')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('getContactpersoon', []))
    );
  }

  addContactpersoon(contactpersoon :ContactPersoon)  {
    return this.http.post(this.baseURl + "contactpersoon/"  ,contactpersoon, this.httpOptions).pipe(
      tap(_ => this.log('addContactpersoon')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('addContactpersoon', []))
    );
  }


  addContactpersoonToRelatie(id:number ,relatieid : number)  {
    return this.http.post(this.baseURl + "contactpersoon/addRelatie/" + id  ,{relatieid:relatieid}, this.httpOptions).pipe(
      tap(_ => this.log('addContactpersoon')),
      tap(e => { this.common.checkAndReportErrors(e)}),
      catchError(this.handleError<any>('addContactpersoon', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


  private log(message: string) {
    console.log(`RelatiesService: ${message}`);
  }

}
